"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theming = require("../../../../theming");

var _Input = _interopRequireWildcard(require("../Input"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var tProps = {};

var getX = function getX(value) {
  var temp = document.getElementById("tempLength");

  if (!temp) {
    console.log("cant be found", document);
    return 0;
  }

  temp.innerText = value;
  return temp.clientWidth + 1; // magic number, bur seems consisten
};

var EmailInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EmailInput, _React$Component);

  function EmailInput(props, context) {
    var _this;

    _classCallCheck(this, EmailInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EmailInput).call(this, props, context));
    _this.state = {
      value: "",
      isValid: false
    };
    _this.emailInput = _react["default"].createRef();
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(EmailInput, [{
    key: "handleChange",
    value: function handleChange(e) {
      var _this2 = this;

      var value = e.target.value;
      var isValid = this.emailInput.current.validity.valid;
      this.setState({
        value: value,
        isValid: isValid
      }, function () {
        if (_this2.props.onChange) {
          _this2.props.onChange(_this2.state);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          value = _this$state.value,
          isValid = _this$state.isValid;
      return _react["default"].createElement(Wrapper, {
        isValid: value && isValid
      }, _react["default"].createElement(_Input["default"], _extends({
        type: "email"
      }, this.props, {
        value: value,
        onChange: this.handleChange,
        ref: this.emailInput
      })), _react["default"].createElement(AtSymbol, {
        isValid: isValid,
        x: getX(value.split("@")[0])
      }, "@"), _react["default"].createElement(AtSymbol, {
        isValid: isValid,
        x: getX(value.split(".")[0])
      }, "."), _react["default"].createElement(Hidden, {
        id: "tempLength"
      }));
    }
  }]);

  return EmailInput;
}(_react["default"].Component);

var Hidden = _styledComponents["default"].div.withConfig({
  displayName: "EmailInput__Hidden",
  componentId: "sc-2f3jl2-0"
})(["position:absolute;visibility:hidden;height:auto;width:auto;white-space:nowrap;"]);

var AtSymbol = _styledComponents["default"].div.withConfig({
  displayName: "EmailInput__AtSymbol",
  componentId: "sc-2f3jl2-1"
})(["", ";border:0;width:auto;color:", ";position:absolute;bottom:0;left:", "px;pointer-events:none;z-index:1;display:flex;align-items:center;"], _Input.inputCss, _theming.color.text, function (_ref) {
  var x = _ref.x;
  return x;
});

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "EmailInput__Wrapper",
  componentId: "sc-2f3jl2-2"
})(["position:relative;"]);

EmailInput.propTypes = {
  onChange: _propTypes["default"].func
};
EmailInput.defaultProps = {};
EmailInput.themeProps = tProps;
var _default = EmailInput;
exports["default"] = _default;